import { LogoMark } from '@/components/logo-mark';
import FadeIn from '@/components/motion/fade-in';
import { SendIcon } from 'lucide-react';
import AuthLayout from './auth-layout';

type AuthTelegramGateProps = {
	message?: string;
};

export default function AuthTelegramGate({
	message = 'Откройте приложение в Telegram, чтобы продолжить',
}: AuthTelegramGateProps) {
	return (
		<AuthLayout>
			<FadeIn className='flex flex-col items-center gap-6 text-center'>
				<div className='text-[var(--auth-white)]' style={{ width: 88, height: 88 }}>
					<LogoMark className='h-full w-full' />
				</div>
				<div className='flex flex-col items-center gap-3'>
					<div className='flex h-12 w-12 items-center justify-center rounded-2xl border border-white/15 bg-white/5 backdrop-blur-sm'>
						<SendIcon className='text-[var(--auth-red)]' size={22} />
					</div>
					<p className='max-w-xs text-sm leading-relaxed text-white/70'>{message}</p>
				</div>
			</FadeIn>
		</AuthLayout>
	);
}
